import React, { useMemo } from 'react';
import { Box, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Iconify from '../common/iconify.component';
import { ASSET_TYPE } from '../../config/const.config';

const AssetSummaryLabel = ({ value }) => {
  const assetItems = useMemo(
    () =>
      Object.keys(value || {}).map((key) => {
        let icon = '';
        let palette = '';
        if (key === 'VIDEO') {
          icon = 'octicon:video-16';
          palette = 'primary';
        } else if (key === 'THUMBNAIL') {
          icon = 'solar:gallery-wide-bold';
          palette = 'warning';
        } else if (key === 'SLIDES') {
          palette = 'error';
        } else if (key === 'PODCAST') {
          palette = 'success';
        } else if (key === 'TRANSCRIPT_PDF') {
          palette = 'info';
        } else if (key === 'TRANSCRIPT_DOCX') {
          palette = 'secondary';
        }

        return {
          assetType: key,
          tooltipText:
            ASSET_TYPE[key]?.label ||
            key.charAt(0).toUpperCase() + key.slice(1).toLowerCase(),
          count: value[key]?.count || 0,
          total: value[key]?.total || 0,
          icon: ASSET_TYPE[key]?.icon || icon,
          assetAvailable: (value[key]?.count || 0) > 0,
          palette,
        };
      }),
    [value]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 0.75,
      }}
    >
      {assetItems.map((item) => (
        <Tooltip key={item.assetType} arrow title={item.tooltipText}>
          <Box
            sx={(theme) => ({
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0.5,
              minWidth:
                item.assetType !== 'VIDEO' && item.assetType !== 'THUMBNAIL'
                  ? 56
                  : 24,
              px: 0.65,
              py: 0.45,
              borderRadius: 999,
              bgcolor: item.assetAvailable
                ? alpha(theme.palette[item.palette].main, 0.1)
                : alpha(theme.palette.grey[500], 0.08),
              color: item.assetAvailable
                ? theme.palette[item.palette].main
                : theme.palette.text.disabled,
              border: item.assetAvailable
                ? '1px solid transparent'
                : `1px dashed ${alpha(theme.palette.grey[500], 0.35)}`,
              fontSize: 12,
              fontWeight: 700,
              lineHeight: 1,
            })}
          >
            <Iconify icon={item.icon} width={14} />
            {item.assetType !== 'VIDEO' && item.assetType !== 'THUMBNAIL'
              ? `${item.count}/${item.total}`
              : ''}
          </Box>
        </Tooltip>
      ))}
    </Box>
  );
};

AssetSummaryLabel.propTypes = {
  value: PropTypes.object.isRequired,
};

export default AssetSummaryLabel;
